var map = {
	"./box.svg": "../../packages/micro-components/BasisIcon/icons/box.svg",
	"./close.svg": "../../packages/micro-components/BasisIcon/icons/close.svg",
	"./empty-nomsg.svg": "../../packages/micro-components/BasisIcon/icons/empty-nomsg.svg",
	"./empty-norecord.svg": "../../packages/micro-components/BasisIcon/icons/empty-norecord.svg",
	"./empty.svg": "../../packages/micro-components/BasisIcon/icons/empty.svg",
	"./upload.svg": "../../packages/micro-components/BasisIcon/icons/upload.svg",
	"./wszy-logo-slogan.svg": "../../packages/micro-components/BasisIcon/icons/wszy-logo-slogan.svg",
	"./wszy-logo.svg": "../../packages/micro-components/BasisIcon/icons/wszy-logo.svg",
	"./wszy-slogan.svg": "../../packages/micro-components/BasisIcon/icons/wszy-slogan.svg",
	"./zljm-logo.svg": "../../packages/micro-components/BasisIcon/icons/zljm-logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/micro-components/BasisIcon/icons sync recursive \\.svg$";